// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: "0.1.0",
  appServerUrl: 'http://localhost:10001',
  maxResourceFileSize: 100 * 1024 * 1024,//100mb
  firebaseConfig: {
    apiKey: "AIzaSyAmYrN7dk4vT1LbvCgLuOMs43i-GkPKP6E",
    authDomain: "dev-tsl.firebaseapp.com",
    projectId: "dev-tsl",
    storageBucket: "dev-tsl.appspot.com",
    messagingSenderId: "942937713927",
    appId: "1:942937713927:web:1bec60156f6ac265a629a2"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
